import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { Subtitle, Caption } from "src/atoms/typography";
import RoundButton from "src/components/RoundButton";
import SectionDivider from "./SectionDivider";

export default function CameraSection({
  list,
  icon,
  subtitle,
  handleCameraChange,
  selectedCameraId,
  isFront,
  isBack,
  isExternal
}) {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" justifyContent="center" flexDirection="column">
      <Flex alignItems="center" justifyContent="center">
        {list.map((camera, id) => {
          const isSelected = selectedCameraId === camera.cameraId;
          return (
            <Flex
              key={camera.cameraId}
              mr={
                list.length !== id + 1 && (isBack || isFront) ? "16px" : "0px"
              }
            >
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <RoundButton
                  onClick={() => handleCameraChange(camera.cameraId)}
                  color={isSelected ? "surfaceElevated1" : "white"}
                  bg={isSelected ? "white" : "white12"}
                  iconFill={isSelected ? "#A0A0A0" : "white"}
                  size="40px"
                  icon={icon}
                >
                  {isBack && camera.zoomLevel && (
                    <Subtitle>
                      {Math.round(camera.zoomLevel * 10) / 10}x
                    </Subtitle>
                  )}
                </RoundButton>
                {isExternal && (
                  <Caption
                    text-align="center"
                    maxWidth="58px"
                    mt="6px"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    display="-webkit-box"
                    color="mediumEmphasis"
                    sx={{
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2
                    }}
                  >
                    {camera.name}
                  </Caption>
                )}
              </Flex>
              {list.length - 1 !== id && isExternal && <SectionDivider />}
            </Flex>
          );
        })}
      </Flex>
      {(isBack || isFront) && (
        <Caption color="mediumEmphasis" mt="6px" textAlign="center">
          {t(subtitle)}
        </Caption>
      )}
    </Flex>
  );
}
